<script lang="ts">
  import type { ReviewInterface } from '$types/interfaces';

  export let review: ReviewInterface;
  export let border = true;
</script>

<div class="review" class:review--with-border={border}>
  <p>{@html review.text}</p>
  <h3>{@html review.name}</h3>
  <h4 class="color-caramel">
    {@html review.title}
  </h4>
</div>

<style lang="scss">
  .review {
    background-color: $color-white;
    border-radius: 13px;
    padding: 48px 50px 53px;
    display: flex;
    flex-direction: column;
    min-height: 380px;
    height: 100%;
    &--with-border {
      border: 1px solid rgba($color-medium-gray, 0.8);
    }
    p {
      font-size: 17px;
      line-height: 32px;
      font-style: italic;
      margin-bottom: auto;
    }
    h3 {
      font-size: 20px;
      line-height: 32px;
      font-weight: 800;
      margin-top: 12px;
      margin-bottom: 8px;
    }
    h4 {
      font-size: 17px;
      line-height: 32px;
      font-weight: 400;
    }
  }
  @include mobile {
    .review {
      padding: 25px 21px;
      min-height: 350px;
      width: 90vw;
      margin: auto;
      p {
        font-size: 14px;
        line-height: 1.8;
      }
      h3 {
        font-size: 20px;
        line-height: 32px;
        margin-bottom: 0;
      }
      h4 {
        font-size: 17px;
        line-height: 28px;
      }
    }
  }
</style>
